import { useState, useMemo, useCallback, ChangeEvent } from 'react';
import { Cooperative } from 'models';

import { NoData } from 'components';
import { TextField } from '@material-ui/core';

import { useStyles } from './style';
import clsx from 'clsx';

interface Props {
  cooperatives: Cooperative[];
  activeId: string;
  handleChange: (id: string) => void;
}

const CooperativePickerList: React.FC<Props> = ({
  cooperatives,
  activeId,
  handleChange,
}) => {
  const classes = useStyles();
  const [cooperativeFilterVal, setCooperativeFilterVal] = useState('');

  const handleChangeCooperativeFilterValue = useCallback(
    (e: ChangeEvent<HTMLInputElement>) => {
      const { value } = e.target;

      setCooperativeFilterVal(value);
    },
    []
  );

  let coops = useMemo(() => {
    return cooperatives.filter((coop) => {
      return coop.Name?.toLowerCase().includes(
        cooperativeFilterVal.toLowerCase()
      );
    });
  }, [cooperativeFilterVal, cooperatives]);

  return (
    <>
      <div className={classes.inputWrapper}>
        <TextField
          placeholder="Hae taloyhtiön nimellä"
          value={cooperativeFilterVal}
          onChange={handleChangeCooperativeFilterValue}
          classes={{
            root: classes.textFieldRoot,
          }}
          InputProps={{
            disableUnderline: true,
            classes: {
              root: classes.inputRoot,
            },
          }}
        />
      </div>
      {coops.length ? (
        <ul className={classes.list}>
          {coops.map((cooperative) => {
            const isActive = cooperative.Id === activeId;

            return (
              <li
                key={cooperative.Id}
                onClick={
                  isActive ? undefined : () => handleChange(cooperative.Id)
                }
                className={clsx(classes.item, {
                  [classes.activeItem]: cooperative.Id === activeId,
                })}
              >
                <span className={classes.cooperativeName}>
                  {cooperative.Name}
                </span>
              </li>
            );
          })}
        </ul>
      ) : (
        <NoData />
      )}
    </>
  );
};

export default CooperativePickerList;
